import React, { useState } from 'react';
import './Navbar.css';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="logo">Port<span>Folio</span></div>
      <div className={`menu-icon ${open ? 'open' : ''}`} onClick={() => setOpen(!open)}>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <ul className={`nav-links ${open ? 'active' : ''}`}>
        <li><a href="#home" onClick={() => setOpen(false)}>Home</a></li>
        <li><a href="#about" onClick={() => setOpen(false)}>About</a></li>
         <li><a href="#skills" onClick={() => setOpen(false)}>Skills</a></li>
        <li>
  <a 
    href="/dk_resume.pdf" 
    download
    onClick={(e) => {
      e.preventDefault();
      const link = document.createElement('a');
      link.href = '/dk_resume.pdf';
      link.download = 'dk_resume.pdf';
      link.click();
      setOpen(false);
    }}
  >
    Resume
  </a>
</li>
        <li><a href="#projects" onClick={() => setOpen(false)}>Projects</a></li>
        <li><a href="#testimonials">Reviews</a></li>
        <li><a href="#contact" onClick={() => setOpen(false)}>Contact</a></li>
      </ul>
    </nav>
  );
};

export default Navbar;